import * as React from "react"
import { Box } from "@mui/material"


export default function SkuLabelWrap({label, maxWidth=120}) {
    return <Box
        component="span"
        title={label}
        sx={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: `${maxWidth}px`,
            display: "inline-block",
            verticalAlign: "middle"
        }}
    >
        {label}
    </Box>
}